import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@material-ui/pickers';

const ReservationPicker = ({ field, form }) => {
  const handleChange = useCallback(date => form.setFieldValue(field.name, date, true), [field.name, form]);

  return (
    <div>
      <DatePicker
        name={field.name}
        value={field.value}
        error={form.errors[field.name]}
        onError={(_, error) => form.setFieldError(field.name, error)}
        onChange={handleChange}
        inputVariant="outlined"
        format="YYYY.MM.DD"
        autoOk
        disablePast
        disableToolbar
      />
    </div>
  );
};

ReservationPicker.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      title: PropTypes.string,
    }).isRequired,
    touched: PropTypes.shape({
      title: PropTypes.bool,
    }).isRequired,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
  }).isRequired,
};

export default ReservationPicker;
